export interface AiAgentJobRequest {
    /** The type of AI task to run — must match a registered agent handler */
    taskType: string;

    /** Agent-specific payload — shape depends on taskType */
    payload: Record<string, unknown>;
}
